import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../../../assets/css/StudentShortDetails.css';
import exporticon from '../../../assets/icons/export-data.svg';
import financeIcon from '../../../assets/icons/finance.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { activitiesData } from '../ActivityDashboard/data';
import AdvanceTable from '../../../Utils/AdvanceTables';
import SearchingBar from '../../../Utils/Searching';
import SingleActivityDetails from './SingleActivityDetails';
import { getData, getDataById, Postdata } from '../../../API/GlobalApi';
import Notifier from '../../../Utils/notify';
import { useTableFade } from '../../../Utils/tableFadeHooks';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader';
import TableSkeleton from '../../../Utils/TableSkeleton';
import { useHasPermission } from '../../../Utils/checkPermissions';
import { useWebSocket } from '../../../Utils/WebSocketHooks';
import { StudentLedgerDetails } from '../../../Component/Modals/StudentLegerDetails';
import { copyToClipboard } from '../../../Utils/copyToClipboard';
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS_UTC } from '../../../Utils/data&dateTime';
import Select from "react-select";
import { GridToggleIcon, reactSelectStyles } from '../../../Utils/selectBoxStyle';
import SpinnerLoader from '../../../Utils/Spinner';
import ReconciliationStatsBar from './components/ReconciliationStatsBar';
import ConfirmationModal from '../../../Component/Modals/ConfirmationModal';
import BulkApprovalModal from './components/BulkApprovalModal';
import BulkLibraryApprovalModal from './components/BulkLibraryApprovalModal';
export default function ActivityDetailsList() {

    const { id } = useParams();
    const activityId = Number(id.replace(":", ""));
    const activityIdRef = useRef(activityId);

    useEffect(() => {
        activityIdRef.current = activityId;
    }, [activityId]);
    const selectedDetails = activitiesData.find(item => item.id === activityId);
    // const students = selectedDetails?.details?.selected_students || [];
    const dues = selectedDetails?.details?.dues_summary || {};
    const nocs = selectedDetails?.details?.nocs_summary || {};
    const statusCounts = selectedDetails?.admit_status_count || {};
    const { tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();
    const [selectedStudent, setselectedStudent] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [filterLoading, setFilterLoading] = useState(false);
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [openStudentLedgerReportModal, setStudentLedgerReportModal] = useState(false)
    const navigate = useNavigate()

    const [activity, setActivity] = useState({
        activity_name: "",
        description: "",
        start_date: "",
        end_date: "",
        exam_start_date: "",
        activity_event_type: "",
        practical_subject: "",
        students: { results: [], count: 0 },
    });
    const [students, setStudents] = useState([]);   // stores students list
    const [loading, setLoading] = useState(false);  // optional loader
    const skipSpinnerRef = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filterQueryString, setFilterQueryString] = useState({});
    const [filterStudent, setfilterStudent] = useState([])
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [selectedFeeDetails, setselectedFeeDetails] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    const [searchValue, setSearchValue] = useState("");
    const [isSearchMode, setIsSearchMode] = useState(false);
    // At the top of your component
    const [backgroundLoading, setBackgroundLoading] = useState(false);
    const isFirstLoadRef = useRef(true);

    const hasPermission = useHasPermission();
    const canSendAdmitCardLink = hasPermission('can-send-admit-card-download-link');
    const canViewStudentLedger = hasPermission('can-view-student-ledger-details');
    const canSubmitReconciliation = hasPermission('can-submit-accounts-reconciliation-report');
    const canSubmitLibraryReconciliation = hasPermission('can-submit-library-reconciliation-report');
    const [bulkSending, setBulkSending] = useState(false);
    const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);
    const [bulkFinanceConfirmOpen, setBulkFinanceConfirmOpen] = useState(false);
    const [bulkLibraryConfirmOpen, setBulkLibraryConfirmOpen] = useState(false);
    const [reconciliationRefreshKey, setReconciliationRefreshKey] = useState(0);

    const handleBulkSendAdmitCardLink = async () => {
        setBulkSending(true);
        try {
            const res = await Postdata(`academics/activities/send-bulk-whatsapp-download-admit-card/`, {
                // link_to_admit_card: `${process.env.REACT_APP_WINDOW_BASEURL2}admitcard/fee/payment`,
                activity_id: activityId,
                link_to_admit_card: `${process.env.REACT_APP_WINDOW_BASEURL2}admitcard/fee/payment`,
            });
            console.log("res in bulk",res);
            if (res?.error) {
                Notifier.error(res.error);
            } else {
                const queued = res?.queued ?? 0;
                const skipped = res?.skipped ?? 0;
                const total = res?.total ?? 0;
                Notifier.success(
                    `✅ Bulk send started! ${queued} of ${total} students will receive the admit card link on WhatsApp. ${skipped > 0 ? `${skipped} skipped (already sent or report not yet submitted).` : ''}`
                );
            }
        } catch (err) {
            Notifier.error('Failed to send bulk admit card links');
        } finally {
            setBulkSending(false);
        }
    };

    const location = useLocation();
    const skipNextFetchRef = useRef(false);
    const mainOptions = [
        { label: "No Dues Clearance", value: "no_dues_clearance" },
        { label: "Library NOC Clearance", value: "library_noc_clearance" },
    ];


    const statusOptions = [
        { label: "Pending", value: "pending" },
        { label: "Completed", value: "completed" },
    ];

    const [selectedDueClearance, setSelectedDueClearance] = useState(null);  // prechecks or status
    const [selectedStatus, setSelectedStatus] = useState(null);              // pending or completed

    const admitCardStatus = [
        { label: "Pending", value: "pending" },
        { label: "Completed", value: "completed" },
    ];

    const [selectedAdmitCardStatus, setSelectedAdmitCardStatus] = useState(null);
    const [admitCardAvailablity, setAdmitCardAvailability] = useState(null);


    const [selectedStatusOptions, setSelectedStatusOption] = useState(null); // no default selected
    const [studentInfo, setStudentInfo] = useState({
        userId: null,
        mobile: null,
    });

    const invagilationsOptions = [
        { label: "Pending", value: "pending" },
        { label: "Complete", value: "complete" },
    ];

    const [selectedInvigilationsMode, setSelectedInvigilationsMode] = useState(null);


    useEffect(() => {
        if (location.state?.prefillSearch) {
            const regNo = location.state.prefillSearch;

            setSearchValue(regNo);
            searchValueRef.current = regNo;
            setIsSearchMode(true);
            setIsSearching(false);
            setCurrentPage(0);

            // ✅ IMPORTANT
            setIsLoading(false);
            setSearchLoading(true);
            setFilterLoading(true)
            skipNextFetchRef.current = true;
            const timer = setTimeout(() => {
                window.history.replaceState({}, document.title);
            }, 500);
            return () => clearTimeout(timer);

        }
    }, [location.state]);

    // const handleSearchClear = () => {
    //     searchValueRef.current = "";
    //     setSearchValue("");
    //     setIsSearchMode(false);
    //     console.log("modalopenquerref",modalOpenQueryRef)
    //     // ✅ reset location.state safely
    //     navigate(location.pathname, { replace: true, state: null });
    // };




    const handleSearchClear = () => {
        // Clear search only
        searchValueRef.current = "";
        setSearchValue("");
        setIsSearchMode(false);

        // ❌ DO NOT touch filters
        // ❌ DO NOT reset modalOpenQueryRef

        // Update stored query safely
        modalOpenQueryRef.current.query = "";

        // Fetch again using EXISTING filters
        const formattedQuery = new URLSearchParams(
            modalOpenQueryRef.current.filters || {}
        ).toString();

        getActivityDatas(
            0,
            sortFieldRef.current,
            sortOrderRef.current,
            formattedQuery,
            true,
            true
        );

        // Optional: clean URL without nuking state
        navigate(location.pathname, { replace: true });
    };



    const getActivityDatas = async (
        page = 0,
        field = sortField,
        order = sortOrder,
        query = filterQueryString,
        force = false,
        skipSearchStateReset = false
    ) => {


        // ------------------------
        // 1. Stop calls during typing
        // ------------------------
        if (!force && isSearching) return;

        const pageNumber = page + 1;
        const params = new URLSearchParams(query || "");

        // ------------------------
        // 2. Compute search text
        // ------------------------
        const searchText = (searchValueRef.current || "").trim();


        // Apply or remove search param
        if (searchText) {
            params.set("search", searchText);
        } else {
            params.delete("search");
        }

        // Sorting
        if (order) params.set("sort_by", order);

        // Page
        params.set("page", pageNumber);

        // const url = `academics/activities/${activityId}/?${params.toString()}`;

        const url = `academics/activities/${activityIdRef.current}/?${params.toString()}`;
        // ------------------------
        // 3. Select correct loader
        // ------------------------
        if (skipSearchStateReset) {
            setBackgroundLoading(true);
        } else if (isFirstLoadRef.current) {
            setIsLoading(true);
        } else {
            setSearchLoading(true);
        }

        try {
            const res = await getData(url);
            setActivity({
                activity_name: res.activity_name || "",
                description: res.description || "",
                start_date: res.start_date || "",
                end_date: res.end_date || "",
                exam_start_date: res.exam_start_date || "",
                students: res.students || { results: [], count: 0 },
                verified_students: res.verified_students || "",
                activity_event_type: res.activity_event_type || "",
                practical_subject: res.practical_subject || ""
            });

            // Update filtered list
            setfilterStudent({
                students: res.students || { results: [], count: 0 },
            });

            // Update count
            setTotalCount(res.students?.count || 0);

            // Auto-select first student
            if (
                isInitialLoad &&
                res.students?.results?.length > 0 &&
                !selectedStudent
            ) {
                setselectedStudent(res.students.results[0]);
            }
            // ✅ Mark first load done here
            if (isFirstLoadRef.current) isFirstLoadRef.current = false;
            return res;
        } catch (err) {
            Notifier.error(err);
            setActivity([]);
            setTotalCount(0);
            return null;
        } finally {
            // Clear loaders
            if (skipSearchStateReset) {
                setBackgroundLoading(false);
            } else if (isInitialLoad) {
                setIsLoading(false);
            } else {
                setSearchLoading(false);
            }

            setFilterLoading(false);
        }
    };


    const currentPageRef = useRef(currentPage);


    const [activityStats, setActivityStats] = useState({
        activity_id: null,
        activity_name: "",
        total_students: 0,
        completed_students: 0,
        authentication_methods: [],
        pre_check_methods: [],
        students_with_admit_card_count: 0
    });

    const getActivityStatsCount = async () => {
        try {
            const res = await getData(`academics/activities/stats/?activity_id=${activityId}`);

            if (!res.error) {
                setActivityStats({
                    activity_id: res.activity_id,
                    activity_name: res.activity_name,
                    total_students: res.total_students,
                    completed_students: res.completed_students,
                    authentication_methods: res.authentication_methods || [],
                    pre_check_methods: res.pre_check_methods || [],
                    students_with_admit_card_count: res.students_with_admit_card_count,
                    practical_admit_card_scanned_count: res.practical_admit_card_scanned_count
                });
            }
        } catch (error) {
            console.error("Error fetching activity stats", error);
        }
    };

    useEffect(() => {
        if (!activityId) return;
        getActivityStatsCount();
    }, [activityId]); // <-- now it runs every time activityId changes




    useEffect(() => {
        if (skipNextFetchRef.current) {
            skipNextFetchRef.current = false;
            return;
        }

        if (isSearching) return;

        getActivityDatas(
            currentPage,
            sortFieldRef.current,
            sortOrderRef.current,
            filterQueryString,
            true,
            isSearchMode
        ).finally(() => stopTableLoading());

    }, [currentPage, activityId, isSearching, isSearchMode]);


    const modalOpenRef = useRef(false);

    useEffect(() => {
        modalOpenRef.current = openStudentLedgerReportModal;
    }, [openStudentLedgerReportModal]);


    const searchValueRef = useRef("");
    useEffect(() => {
        searchValueRef.current = searchValue;
    }, [searchValue]);

    // const WS_URL = 'ws://192.168.1.44:9000/ws/student-ledger-updates/';




    // Ref to store last query info when modal is opened
    const modalOpenQueryRef = useRef({
        page: 0,
        query: '',
        sortField,
        sortOrder,
        filters: {
            sort_type: null,
            sort_by: null,
            admit_card_status: null,
            admit_card_available: null,
        },
    });




    useEffect(() => {
        modalOpenQueryRef.current.filters = {
            sort_type: selectedDueClearance?.value || null,           // no_dues_clearance
            sort_by: selectedStatus?.value || null,                   // completed / pending
            admit_card_status: selectedAdmitCardStatus?.value || null, // pending
            admit_card_available: admitCardAvailablity?.value ?? null, // true / false
        };
    }, [selectedDueClearance, selectedStatus, selectedAdmitCardStatus, admitCardAvailablity]);


    // Convert filters object to query object
    const buildQueryFromFilters = () => {
        const filters = modalOpenQueryRef.current.filters || {};

        return Object.fromEntries(
            Object.entries(filters).filter(
                ([_, value]) => value !== null && value !== undefined
            )
        );
    };





    const openModalStudentIdRef = useRef(null);
    const handleCloseModal = () => {
        setStudentLedgerReportModal(false)
        openModalStudentIdRef.current = null;
    };

    // Open modal
    const handleNoDuesClick = async (e, student) => {
        e.stopPropagation();

        if (!student) return;

        const studentId = student.student_id;

        openModalStudentIdRef.current = studentId;

        const trimmedSearch = searchValueRef.current?.trim() || "";
        // Store current search/page/sort
        modalOpenQueryRef.current = {
            ...modalOpenQueryRef.current,   // 🔥 KEEP existing filters
            page: currentPageRef.current,
            sortField,
            sortOrder,
            query: trimmedSearch
                ? `search=${encodeURIComponent(trimmedSearch)}`
                : "",
            filters: {
                ...modalOpenQueryRef.current.filters, // 🔥 KEEP dropdown filters
            },
        };
        setStudentLedgerReportModal(true);

        // Load selected student's ledger
        if (studentId) await getStudentById(studentId);
    };


    const buildQueryFromCurrentFilters = () => {
        const filters = modalOpenQueryRef.current.filters || {};
        const query = {};

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== "") {
                query[key] = value;
            }
        });

        return query;
    };




    const WS_URL = process.env.REACT_APP_API_WSS_URL_ACTIVITY;


    const { connected, readyState, connect: connectActivity, disconnect: disconnectActivity } = useWebSocket(WS_URL, {
        onOpen: () => console.log("WS Connected"),

        onMessage: async (msg) => {
            if (msg?.type !== "student_ledger_update") return;

            const isModalOpen = modalOpenRef.current;
            // const studentId = msg?.student_id;
            const updatedStudentId = msg?.student_id;
            // 💥 If modal is CLOSED → refresh list only
            if (!modalOpenRef.current) {
                const { page, sortField, sortOrder, } =
                    modalOpenQueryRef.current || {};
                // ✅ build FULL query string from current filters
                const finalQuery = buildQueryFromCurrentFilters();
                await getActivityDatas(
                    page,
                    sortField,
                    sortOrder,
                    finalQuery,
                    true,
                    true
                );
                await getActivityStatsCount()
                return;
            }
            // Modal must be OPEN and IDs must MATCH
            if (!modalOpenRef.current) return;

            if (updatedStudentId !== openModalStudentIdRef.current) {
                // ❌ this update is for another student → ignore
                return;
            }

            // ✅ Refresh same student's ledger
            await getStudentById(updatedStudentId);

            if (isModalOpen) {
                const { page, sortField, sortOrder, filters } = modalOpenQueryRef.current;
                const query = buildQueryFromFilters();
                setBackgroundLoading(true);
                // 🔥 FIX HERE — clean query (avoid duplicated search key)
                const searchValue = new URLSearchParams(query || "").get("search") || "";
                const urlQuery = searchValue ? `search=${encodeURIComponent(searchValue)}` : "";

                try {
                    await getActivityDatas(
                        page,
                        sortField,
                        sortOrder,
                        { ...filters },
                        true,  // force
                        true   // preserve search state
                    );
                } finally {
                    setBackgroundLoading(false);
                }
            }
        },


        onClose: () => console.log("WS Disconnected"),
        onError: (err) => console.error("WS Error:", err),
    });


    const WS_URL_LIBRARY_NOC = process.env.REACT_APP_API_WSS_URL_LIBRARY


    // --- Library NOC WS ---
    const {
        connected: nocConnected,
        connect: connectNOC,
        disconnect: disconnectNOC,
    } = useWebSocket(WS_URL_LIBRARY_NOC, {
        onOpen: () => console.log("Library NOC WS Connected"),
        onMessage: async (msg) => {
            console.log("msg web sockrtes", msg)
            if (msg?.type !== "library_noc_completed") return;

            console.log("Library NOC update:", msg);

            const isModalOpen = modalOpenRef.current;

            // --------------------------
            // 1️⃣ Modal is CLOSED → refresh activity list
            // --------------------------
            if (!isModalOpen) {
                const { page, sortField, sortOrder } = modalOpenQueryRef.current || {};
                const query = buildQueryFromFilters();
                await getActivityDatas(
                    page,
                    sortField,
                    sortOrder,
                    query,
                    true,  // force
                    true   // skipSearchStateReset
                );
                await getActivityStatsCount();
                return;
            }

            // --------------------------
            // 2️⃣ Modal is OPEN → refresh same logic
            // --------------------------
            const { page, sortField, sortOrder } = modalOpenQueryRef.current;
            const query = buildQueryFromFilters();
            setBackgroundLoading(true);
            try {
                // Clean search query
                const searchValue = new URLSearchParams(query || "").get("search") || "";
                const urlQuery = searchValue ? `search=${encodeURIComponent(searchValue)}` : "";

                await getActivityDatas(
                    page,
                    sortField,
                    sortOrder,
                    query,
                    true, // force refresh
                    true  // preserve search state
                );

                await getActivityStatsCount();
            } finally {
                setBackgroundLoading(false);
            }
        },
        onClose: () => console.log("Library NOC WS Disconnected"),
        onError: (err) => console.error("Library NOC WS Error:", err),
    });
    const [admitCardSocketInfo, setAdmitCardSocketInfo] = useState(null);

    //  const WS_URL_STUDENT_RESPONSES = 'ws://192.168.1.44:9000/ws/academics/activity-updates/'

    const WS_URL_STUDENT_RESPONSES = process.env.REACT_APP_API_WSS_URL_STUDENT_UPDATE

    console.log("web sockets urls for student activity", WS_URL_STUDENT_RESPONSES)


    const {
        connect: connectStudentResponses,
        disconnect: disconnectStudentResponses,
    } = useWebSocket(WS_URL_STUDENT_RESPONSES, {
        onOpen: () => console.log("Student Responses WS Connected"),

        onMessage: async (msg) => {
            console.log("Student Responses WS Msg:", msg);

            // Only handle student added type

            if (msg?.type === "activity_admit_card_verified") {
                const { student_id, timestamp, created_by } = msg;

                setAdmitCardSocketInfo({
                    student_id,
                    created_at: timestamp,
                    created_by,
                });
            }

            if (
                msg?.type === "reconciliation_report_submitted" ||
                msg?.type === "reconciliation_report_revoked"
            ) {
                // Bump the stats bar.
                setReconciliationRefreshKey((k) => k + 1);
                // If the event is for the activity we're currently viewing, refetch
                // the rows so per-student chips/buttons update.
                if (msg.activity_id && Number(msg.activity_id) === Number(activityIdRef.current)) {
                    try {
                        const formattedQuery = buildQueryFromCurrentFilters();
                        await getActivityDatas(
                            currentPageRef.current,
                            sortFieldRef.current,
                            sortOrderRef.current,
                            formattedQuery,
                            true,
                            true
                        );
                        await getActivityStatsCount();
                    } catch (e) {
                        console.error("Failed to refresh after reconciliation event", e);
                    }
                }
                return;
            }

            if (msg?.type !== "activity_student_added") return;



            const searchText = (searchValueRef.current || "").trim();
            const regNo = msg.registration_number;
            const studentName = msg.student_name;
            const activityName = msg.activity_name;

            try {
                if (!searchText) {
                    // ✅ Search is empty → populate search with reg no
                    searchValueRef.current = regNo;
                    setSearchValue(regNo);
                    setIsSearching(true);
                    setIsSearchMode(true);
                    setCurrentPage(0);

                    const queryParams = new URLSearchParams(filterQueryString);
                    queryParams.set("search", regNo);
                    queryParams.set("page", 1);

                    setBackgroundLoading(true);
                    await getActivityDatas(
                        currentPage,
                        sortFieldRef.current,
                        sortOrderRef.current,
                        Object.fromEntries(queryParams.entries()),
                        true,  // force
                        true   // preserve search state
                    );
                    await getActivityStatsCount();
                } else {
                    // ✅ Search has value → notifier only
                    Notifier.info(
                        `Student ${studentName} (Reg. No: ${regNo}) has been added to the activity "${activityName}".`
                    );
                }
            } finally {
                // ✅ ALWAYS refresh stats (search or not)
                getActivityStatsCount();
                setBackgroundLoading(false);
            }
        },

        onClose: () => console.log("Student Responses WS Disconnected"),
        onError: (err) => console.error("Student Responses WS Error:", err),
    });

    // Connect/disconnect on mount/unmount
    useEffect(() => {
        connectStudentResponses();
        return () => disconnectStudentResponses();
    }, []);
    useEffect(() => {
        console.log("🔥 admitCardSocketInfo updated:", admitCardSocketInfo);
    }, [admitCardSocketInfo])




    useEffect(() => {
        // connect both on mount
        connectActivity();
        connectNOC();

        // disconnect both on unmount
        return () => {
            disconnectActivity();
            disconnectNOC();
        };
    }, []);

    const skipNextLoaderRef = useRef(false);

    const handleSetSearchResults = async (data, searchText = searchValueRef.current) => {


        let results = [];

        // normalize results from API
        if (Array.isArray(data)) {
            results = data;
        } else if (data?.results) {
            results = data.results;
        } else if (data?.students?.results) {
            results = data.students.results;
        }

        // 🔹 If results found in current activity → update state
        if (results.length > 0) {
            setfilterStudent({ students: { results, count: results.length } });

            // Update selectedStudent
            const stillExists = results.find(
                (x) => x.student_id === selectedStudent?.student_id
            );

            if (stillExists) setselectedStudent(stillExists);
            else setselectedStudent(results[0]);

            return; // stop here, no need for global search
        }

        // 🔹 If no results, call global search
        try {
            const url = `academics/activities/search-registration/?search=${encodeURIComponent(searchText)}&page=1`;
            const response = await getData(url);
            console.log("responses", response)
            let globalResults = [];
            if (Array.isArray(response)) globalResults = response;
            else if (response?.results) globalResults = response.results;

            if (globalResults.length > 0) {
                // Redirect to first matching activity
                const firstActivityId = globalResults[0].activity_id || globalResults[0].id;
                skipNextLoaderRef.current = true;
                navigate(`/manage-activity/${firstActivityId}`, {
                    state: { prefillSearch: searchText },
                });
            } else {
                // No matches at all
                setfilterStudent({ students: { results: [], count: 0 } });
                setselectedStudent(null);
            }
        } catch (err) {
            console.error(err);
            setfilterStudent({ students: { results: [], count: 0 } });
            setselectedStudent(null);
        }
    };



    const sortFieldRef = useRef(null);
    const sortOrderRef = useRef(null);
    useEffect(() => {
        sortFieldRef.current = sortField;
        sortOrderRef.current = sortOrder;
    }, [sortField, sortOrder]);

    useEffect(() => {
        currentPageRef.current = currentPage;
    }, [currentPage]);


    const handleSort = (field, order) => {
        let sortByValue = order; // default for all columns

        // 🔥 Custom sort for Pre-checks
        if (field === "all_precheck_names") {
            sortByValue = order === "asc" ? "completed" : "pending";
        }

        setSortField(field);
        setSortOrder(sortByValue);

        // 🔥 keep refs in sync
        sortFieldRef.current = field;
        sortOrderRef.current = sortByValue;

        setCurrentPage(0);
        setIsFilterApplied(false);
        setfilterStudent([]);

        const queryParams = new URLSearchParams(filterQueryString || "");
        queryParams.set("sort_by", sortByValue);

        const newQuery = queryParams.toString();
        setFilterQueryString(newQuery);

        // getActivityDatas(0, field, sortByValue, newQuery);
        getActivityDatas(0, field, sortByValue, newQuery, true);

    };





    const getStudentDetailsById = async (id) => {
        try {
            const res = await getData(`students/get-students/${id}/`);
            if (!res.error) {
                const userId = res?.user_id;
                // Find primary mobile number
                const primaryContact = res?.contact_numbers?.find(
                    (item) => item?.is_primary === true
                );
                const mobile = primaryContact?.number || null;
                // Save in state
                setStudentInfo({
                    userId,
                    mobile,
                });
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleRowClick = async (activityId, row) => {
        try {
            // console.log("row", row?.original)
            setselectedStudent(row?.original)
            //   navigate(`/manage-activity/${activityId}`);
            await getStudentDetailsById(row?.original?.student_id)
        } catch (error) {
        }
    };







    const sourceData = useMemo(() => {

        return Object.keys(filterQueryString || {}).length > 0
            ? filterStudent?.students?.results || []
            : activity?.students?.results || [];
    }, [activity?.students?.results, filterStudent?.students?.results, filterQueryString]);

    const filteredAdmitCardCount = filterQueryString?.admit_card_available
        ? filterStudent?.students?.total_admit_cards || 0
        : activity?.students?.total_admit_cards || 0;


    const formattedData = useMemo(() => {
        return sourceData.map((event) => ({
            id: event?.student_id,  // unique
            student_id: event?.student_id,
            full_name: event.full_name,
            permanent_registration_number: event.permanent_registration_number,

            course_name: event.course_name,
            exam_start_date: event.exam_start_date,

            mobile: event?.mobile,
            total_prechecks: event.total_prechecks,
            all_precheck_names: event?.all_precheck_names,

            completed_prechecks: event.completed_prechecks,
            completed_precheck_names: event?.completed_precheck_names,

            total_authentications: event.total_authentications,
            all_authentication_names: event?.all_authentication_names,

            completed_authentications: event.completed_authentications,
            completed_authentication_names: event?.completed_authentication_names,

            exceptional_approval: event?.exceptional_approval,
            finger_iso_1: event.finger_iso_1,
            finger_iso_2: event.finger_iso_2,
            finger_iso_3: event.finger_iso_3,
            activity_completed_issued_by: event.activity_completed_issued_by,
            activity_completed: event?.activity_completed,
            activity_completed_issued_at: event?.activity_completed_issued_at,
            admit_cards_list: event?.admit_cards_list,
            admit_card_link_info: event.admit_card_link_info,
            admit_card_download_count: event.admit_card_download_count,
            practical_info: event.practical_info,
            // completed_authentication_names: event.completed_authentication_names,
            // Reconciliation gate fields (added 2026-05-03):
            required_report_types: event?.required_report_types,
            accounts_report: event?.accounts_report,
            library_report: event?.library_report,
            can_send_admit_card: event?.can_send_admit_card,
            submit_report_actionable_for_user: event?.submit_report_actionable_for_user,
            submit_report_blocked_by_eligibility: event?.submit_report_blocked_by_eligibility,
            accounts_eligible_for_submit: event?.accounts_eligible_for_submit,
            library_eligible_for_submit: event?.library_eligible_for_submit,
            is_defaulter: event?.is_defaulter,
            defaulter_exception: event?.defaulter_exception,
            handleRowClick, // for table row action
        }));
    }, [sourceData]);


    const handlePageChange = ({ selected }) => {
        triggerTableLoading();
        setCurrentPage(selected);

        // getActivityDatas(
        //     selected,
        //     sortFieldRef.current,
        //     sortOrderRef.current,
        //     filterQueryString,
        //     true // <-- force override so API is called
        // );
    };



    const columns = useMemo(
        () => [

            {
                Header: "Student",
                accessor: 'full_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ textAlign: "left", display: "flex", flexDirection: 'column', gap: "5px", cursor: 'pointer' }}
                        // onClick={() => {
                        //   navigate(`/studentDashboard/StudentFullProfile/${row.original.id}`);
                        // }}
                        onClick={() => handleRowClick(row.original.id, row)}                     >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.full_name}
                        </p>
                        <span onClick={() => copyToClipboard(row.original.permanent_registration_number, "Reg No copied")}
                            style={{ textDecoration: 'underline' }} title='Copy Reg.No'>{row.original.permanent_registration_number}</span>


                    </div>
                ),
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Course /Sem</p>,
                accessor: 'course_name',
                disableSortBy: true,
                Cell: ({ row }) => {

                    return (
                        <div>
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                                {row.original?.course_name}
                            </p>

                        </div>
                    );
                }
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Pre-checks</p>,
                accessor: "all_precheck_names",
                className: "col-prechecks",
                disableSortBy: true,
                Cell: ({ row }) => {
                    const original = row.original;
                    const allPrechecks = original?.all_precheck_names || [];
                    const completedPrechecks = original?.completed_precheck_names || [];
                    const exceptionalApproval = original?.exceptional_approval;

                    return (
                        <div style={{ textAlign: "left", display: "flex", flexDirection: 'column', gap: "10px" }} >
                            {allPrechecks.map((precheck) => {
                                const isNoDues = precheck === "No Dues Clearance";
                                const isCompleted = completedPrechecks.includes(precheck);

                                if (isNoDues) {
                                                    // Exceptional approval overrides all normal checks for No Dues
                                    if (exceptionalApproval) {
                                        return (
                                            <span
                                                key={precheck}
                                                style={{
                                                    color: "red",
                                                    textDecoration: "underline",
                                                    fontWeight: 600,
                                                    marginRight: "8px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={(e) => handleNoDuesClick(e, original)}
                                                title="Exceptional approval"
                                            >
                                                {precheck} (✘)
                                            </span>
                                        );
                                    }

                                    return isCompleted ? (
                                        <span
                                            key={precheck}
                                            style={{
                                                color: "green",
                                                fontWeight: 600,
                                                marginRight: "8px",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => handleNoDuesClick(e, original)}
                                            title="No Dues Clearance completed"
                                        >
                                            {precheck} (✔)
                                        </span>
                                    ) : (
                                        <span
                                            key={precheck}
                                            style={{
                                                color: "#FF3B30",
                                                textDecoration: "underline",
                                                fontWeight: 600,
                                                marginRight: "8px",
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => handleNoDuesClick(e, original)}
                                            title="No Dues Clearance pending"
                                        >
                                            {precheck} (✘)
                                        </span>
                                    );
                                }

                                // Normal prechecks
                                return (
                                    <span className={`no-text-cursor ${isCompleted ? "precheck-complete" : "precheck-pending"}`}
                                        key={precheck}
                                        style={{
                                            color: isCompleted ? "green" : "#FF3B30",
                                            fontWeight: 600,
                                            marginRight: "8px",
                                        }}
                                    >
                                        {precheck} ({isCompleted ? "✔" : "✘"})
                                    </span>
                                );
                            })}

                            {/* Minimal addition: show exceptional badge once, outside map */}
                            {exceptionalApproval && (
                                <span
                                    style={{
                                        display: "inline-block",
                                        marginTop: "4px",
                                        padding: "3px 5px",
                                        background: "#166534",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        cursor: "not-allowed",
                                        opacity: 0.6,
                                        textAlign: 'center'
                                    }}
                                >
                                    Exceptional Approval
                                </span>
                            )}
                        </div>
                    );
                },
            },

            {
                Header: () => <p style={{ textAlign: 'left' }}>Authentication</p>,
                accessor: 'completed_authentications',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const allAuth = row.original?.all_authentication_names || [];
                    const completedAuth = row.original?.completed_authentication_names || [];

                    return (
                        <div style={{ textAlign: "left", color: "#222F3E" }} className="no-text-cursor">
                            {allAuth.map((auth, index) => {
                                //  const isCompleted = completedAuth.includes(auth);
                                const completedObj = completedAuth.find(c => c.name === auth);
                                const isCompleted = !!completedObj; // true if completed
                                const isOnline = completedObj?.is_online;
                                return (
                                    <div key={auth} style={{ marginBottom: "4px" }}>
                                        <span
                                            style={{
                                                color: isCompleted ? "green" : "#FF3B30",
                                                fontWeight: 600,
                                                marginRight: "8px"
                                            }}
                                        >
                                            {auth} ({isCompleted ? "✔" : "✘"})
                                        </span>
                                        {isCompleted && (
                                            <div style={{ fontSize: "12px", color: "green", marginLeft: "" }}>
                                                {isOnline ? "Online Verified" : ""}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                }
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Issue Status</p>,

                accessor: 'activity_completed',
                disableSortBy: true,

                Cell: ({ row }) => {
                    const completed = row.original?.activity_completed;

                    return (
                        <div className="no-text-cursor">

                            <p style={{
                                textAlign: 'left',
                                margin: "0",
                                color: completed ? "green" : "red",
                                fontWeight: 600,
                                fontSize: "12px"
                            }}>
                                {completed ? "Completed" : "Pending"}
                            </p>
                        </div>
                    );
                }
            },
            {
                Header: () => <p style={{ textAlign: 'left' }} className="no-text-cursor">Issued By</p>,

                accessor: 'activity_completed_issued_by',
                disableSortBy: true,

                Cell: ({ row }) => {
                    const issuedBy = row.original?.activity_completed_issued_by;

                    const displayValue =
                        issuedBy === null || issuedBy === undefined || issuedBy === ""
                            ? "Not Yet Issued"
                            : issuedBy;

                    return (
                        <div className="no-text-cursor">
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                                {displayValue}

                            </p>
                            <span style={{ fontSize: '15px' }}>
                                {formatDateDDMMYYYYHHMMSS_UTC(row?.original?.activity_completed_issued_at)}
                            </span>
                        </div>
                    );
                }

            }


        ],
        []
    );



    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);


    // Sync selectedStudent after full API reload (clear search)
    useEffect(() => {
        if (!activity?.students?.results) return;

        const fullList = activity.students.results;

        const match = fullList.find(
            (s) => s.student_id === selectedStudent?.student_id
        );

        if (match) {
            setselectedStudent(match);
        } else {
            setselectedStudent(fullList[0]);
        }
    }, [activity?.students?.results]);



    useEffect(() => {
        if (!formattedData || formattedData.length === 0) return;

        const match = formattedData.find(
            (s) => s.student_id === selectedStudent?.student_id
        );

        if (match) {
            setselectedStudent(match);
        } else {
            setselectedStudent(formattedData[0]);
        }
    }, [formattedData]);



    const transformStudentData = (emp) => {
        return {
            id: emp?.student_id || 'N/A',
            name: emp?.student_name || 'N/A',
            profile_type: emp?.student_profile || 'N/A',
            course_name: emp?.course_name || 'N/A',
            contact_number: emp?.primary_contact_number || 'N/A',
            permanent_registration_number: emp?.permanent_registration_number || 'N/A',
            last_credit_payment_date: emp?.last_credit_payment_date,
            last_credit_amount: emp?.last_credit_amount ?? 'N/A',
            last_credit_fee_head: emp?.last_credit_fee_head || 'N/A',
            ledger_data: emp?.ledger_data || [],
            academic_groups: emp?.academic_groups || 'N/A',
            payment_schedule: emp?.payment_schedule || [],
            payment_fee_plan: emp?.payment_fee_plan || [],
            financial_summary: emp.financial_summary,

            handleRowClick: handleRowClick,
        };
    };



    const getStudentById = async (studentId) => {
        if (!studentId) return;
        try {
            const response = await getData(`students/get-student-ledger-details/${studentId}/`);
            // getData returns the response body directly (not wrapped in { data: ... })
            const data = response?.data ?? response;
            if (data) {
                const transformedDetails = transformStudentData(data);
                setselectedFeeDetails(transformedDetails);
            } else {
                setselectedFeeDetails(null);
            }
        } catch (error) {

        }
    };
    const handleSearchValueChange = (value) => {
        const trimmedValue = value.trim();
        searchValueRef.current = value;
        setSearchValue(value);

        modalOpenQueryRef.current.query = trimmedValue
            ? `search=${encodeURIComponent(trimmedValue)}`
            : '';
        modalOpenQueryRef.current.page = 0;
        if (!trimmedValue) {
            setFilterQueryString((prev) => {
                if (!prev || typeof prev !== 'object') return {};
                const { search, ...rest } = prev;
                modalOpenQueryRef.current.filters = rest;

                return rest;
            });

            setIsSearchMode(false);
            setIsSearching(false);
            setCurrentPage(0);
        } else {

            setFilterQueryString((prev) => {
                const updatedFilters = {
                    ...(prev || {}),
                    search: trimmedValue,
                };


                modalOpenQueryRef.current.filters = updatedFilters;

                return updatedFilters;
            });

            setIsSearchMode(true);
            setIsSearching(true);
            setCurrentPage(0);
        }
    };



    return (
        <>
            {isLoading && !modalOpenRef.current ? (
                <TableSkeleton rows={10} columns={6} showHeader={true} />
            ) : (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100vh",
                        overflow: "hidden",
                        position: "relative",
                    }}
                >
                    {/* ───── FIXED TOP: Back + Title + Date + Stats ───── */}
                    <div style={{ flexShrink: 0, padding: "0 12px" }}>
                        <div className="row d-flex justify-content-between align-items-center">

                            {/* FULL ROW: Back + Title | Reconciliation Stats | Dates | Buttons */}
                            <div className="col-12 d-flex align-items-center mb-2" style={{ flexWrap: "nowrap", gap: "8px", minWidth: 0, overflow: "hidden" }}>

                                {/* Back arrow — fixed, never shrinks */}
                                <button
                                    onClick={() => navigate(-1)}
                                    style={{ background: "transparent", border: "none", cursor: "pointer", padding: 0, flexShrink: 0 }}
                                    title="Go back"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none"
                                        stroke="#7F56DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="16" y1="12" x2="4" y2="12" />
                                        <polyline points="10 18 4 12 10 6" />
                                    </svg>
                                </button>

                                {/* Title — shrinks first, truncates */}
                                <h2 className="main-heading m-0" style={{ minWidth: 0, flexShrink: 1 }}>
                                    <span
                                        title={activityStats.activity_name}
                                        style={{
                                            display: "inline-block",
                                            maxWidth: "220px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            verticalAlign: "bottom",
                                            cursor: "default",
                                            fontSize: "clamp(13px, 1.2vw, 18px)",
                                        }}
                                    >
                                        {activityStats.activity_name}
                                    </span>
                                    {activity?.activity_event_type?.name?.includes("Practical") && (
                                        <span style={{ marginLeft: "8px", fontSize: "clamp(11px, 1vw, 14px)" }}>
                                            ({activity.activity_event_type.name})
                                        </span>
                                    )}
                                </h2>

                                {/* Reconciliation Stats — pushed to right, matches row height */}
                                <div style={{ flexShrink: 0, marginLeft: "auto", alignSelf: "stretch", display: "flex", alignItems: "stretch" }}>
                                    <ReconciliationStatsBar
                                        activityId={activityId}
                                        refreshKey={reconciliationRefreshKey}
                                    />
                                </div>

                                {/* Dates — between stats and buttons, matches stats card height */}
                                {activity && (
                                    <div
                                        className="d-flex align-items-center rounded shadow-sm"
                                        style={{
                                            background: "#fff",
                                            borderLeft: "4px solid #7F56DA",
                                            flexShrink: 0,
                                            alignSelf: "stretch",
                                            gap: "12px",
                                            padding: "6px 10px",
                                            fontSize: "13px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        <div className="d-flex flex-column text-start">
                                            <strong style={{ fontSize: "0.85em" }}>Start Date</strong>
                                            <span>{formatDateDDMMYYYY(activity.start_date)}</span>
                                        </div>
                                        <div className="d-flex flex-column text-start">
                                            <strong style={{ fontSize: "0.85em" }}>End Date</strong>
                                            <span>{formatDateDDMMYYYY(activity.end_date)}</span>
                                        </div>
                                        <div className="d-flex flex-column text-start">
                                            <strong style={{ fontSize: "0.85em" }}>Exam Start Date</strong>
                                            <span>{formatDateDDMMYYYY(activity.exam_start_date)}</span>
                                        </div>
                                    </div>
                                )}

                                {/* Bulk Approval Buttons — icon-only on small screens */}
                                <div className="d-flex gap-1" style={{ flexShrink: 0 }}>
                                    {canSubmitReconciliation && (
                                        <button
                                            onClick={() => setBulkFinanceConfirmOpen(true)}
                                            title="Bulk Submit Finance Report"
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 4,
                                                background: "#fff",
                                                border: "2px solid #7F56DA",
                                                borderRadius: "8px",
                                                padding: "5px 10px",
                                                cursor: "pointer",
                                                boxShadow: "0 1px 4px rgba(127,86,218,0.15)",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <img src={financeIcon} alt="Finance" style={{ width: 16, height: 16, opacity: 0.85, flexShrink: 0 }} />
                                            <span style={{ fontSize: 11, fontWeight: 600, color: "#7F56DA" }}>Finance</span>
                                        </button>
                                    )}
                                    {canSubmitLibraryReconciliation && (
                                        <button
                                            onClick={() => setBulkLibraryConfirmOpen(true)}
                                            title="Bulk Submit Library NOC Reports"
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 4,
                                                background: "#fff",
                                                border: "2px solid #7F56DA",
                                                borderRadius: "8px",
                                                padding: "5px 10px",
                                                cursor: "pointer",
                                                boxShadow: "0 1px 4px rgba(127,86,218,0.15)",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7F56DA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                                                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                                            </svg>
                                            <span style={{ fontSize: 11, fontWeight: 600, color: "#7F56DA" }}>Library</span>
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* Stats Cards — single nowrap row, cards shrink on small screens */}
                            <div style={{ display: "flex", flexWrap: "nowrap", alignItems: "stretch", gap: "8px", marginBottom: "8px", minWidth: 0, overflow: "hidden" }}>

                                {/* Students Summary Card */}
                                <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                    <div className="rounded shadow-sm h-100"
                                        style={{ background: "#fff", borderLeft: "4px solid #7F56DA", padding: "8px 10px" }}>
                                        <div className="mb-1">
                                            {activity?.activity_event_type?.name?.includes("Admit Card") && (
                                                <h6 className="m-0" style={{ fontWeight: 600, fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Students (admit card issued)</h6>
                                            )}
                                            {activity?.activity_event_type?.name?.includes("Practical") && (
                                                <h6 className="m-0" style={{ fontWeight: 600, fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Students (Practical)</h6>
                                            )}
                                        </div>
                                        <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap" }}>
                                            <span><strong>Total:</strong> {activityStats.total_students}</span>
                                            <span style={{ color: "green" }}><strong>Completed:</strong> {activityStats.completed_students}</span>
                                            <span style={{ color: "red" }}><strong>Pending:</strong> {activityStats.total_students - activityStats.completed_students}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Admit Card Available */}
                                {activity?.activity_event_type?.name?.includes("Admit Card") && (
                                    <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                        <div className="rounded shadow-sm h-100"
                                            style={{ background: "#fff", borderLeft: "4px solid #7F56DA", padding: "8px 10px" }}>
                                            <h6 className="m-0 mb-1" style={{ fontWeight: 600, fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Admit Card Available</h6>
                                            <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap" }}>
                                                <span style={{ color: "green" }}><strong>Available:</strong> {activityStats.students_with_admit_card_count || 0}</span>
                                                <span style={{ color: "red" }}><strong>Unavailable:</strong> {(activityStats.total_students || 0) - (activityStats.students_with_admit_card_count || 0)}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Practical Participants */}
                                {activity?.activity_event_type?.name?.includes("Practical") && (
                                    <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                        <div className="rounded shadow-sm h-100"
                                            style={{ background: "#fff", borderLeft: "4px solid #7F56DA", padding: "8px 10px" }}>
                                            <h6 className="m-0 mb-1" style={{ fontWeight: 600, fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Participants Status</h6>
                                            <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap" }}>
                                                <span style={{ color: "green" }}><strong>Invigilation:</strong> {activityStats.practical_admit_card_scanned_count || 0}</span>
                                                <span style={{ color: "red" }}><strong>Pending:</strong> {(activityStats.total_students || 0) - (activityStats.practical_admit_card_scanned_count || 0)}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Pre-check Cards */}
                                {activityStats.pre_check_methods?.map((item, i) => {
                                    const pending = item.total_count - item.completed_count;
                                    return (
                                        <div key={i} style={{ flex: "1 1 0", minWidth: 0 }}>
                                            <div className="rounded shadow-sm h-100"
                                                style={{ background: "#fff", borderLeft: "4px solid #7F56DA", padding: "8px 10px" }}>
                                                <h6 className="m-0 mb-1" style={{ fontWeight: 600, fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.pre_check_type}</h6>
                                                <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", fontSize: "clamp(10px, 1vw, 13px)", whiteSpace: "nowrap" }}>
                                                    <span><strong>Total:</strong> {item.total_count}</span>
                                                    <span style={{ color: "green" }}><strong>Completed:</strong> {item.completed_count}</span>
                                                    <span style={{ color: "red" }}><strong>Pending:</strong> {pending}</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* ───── SCROLLABLE BOTTOM: Table (left) + Details (right) ───── */}
                    <div style={{ display: "flex", flex: 1, overflow: "hidden", padding: "0 12px" }}>

                        {/* LEFT: Search (fixed) + Table (scrollable) */}
                        <div style={{ flex: "0 0 66.67%", maxWidth: "66.67%", display: "flex", flexDirection: "column", overflow: "hidden", paddingRight: "12px" }}>

                            {/* ── FIXED: Search bar + Filters ── */}
                            <div style={{ flexShrink: 0, paddingBottom: "8px" }}>
                                <div className="row align-items-end justify-content-end align-items-center">
                                    <div className="col-md-4 d-flex justify-content-start">
                                        <SearchingBar
                                            placeholder="Search by name, registration no."
                                            url={`academics/activities/${activityId}/`}
                                            filterQueryString={filterQueryString}
                                            setResults={handleSetSearchResults}
                                            ref={searchInputRef}
                                            setTotalCount={setTotalCount}
                                            setFilterQueryString={setFilterQueryString}
                                            setSearchLoading={setSearchLoading}
                                            setCurrentPage={setCurrentPage}
                                            setIsSearching={setIsSearching}
                                            isSearching={isSearching}
                                            setIsSearchMode={setIsSearchMode}
                                            setSearchValue={handleSearchValueChange}
                                            searchValue={searchValue}
                                            onSearchClear={handleSearchClear}
                                            showToggle={true}
                                            toggleOnIcon={<GridToggleIcon isDisabled={false} />}
                                            toggleOffIcon={<GridToggleIcon isDisabled={true} />}
                                        />
                                    </div>
                                    <div className="col-md-8 d-flex gap-4">
                                        <div style={{ width: "200px" }}>
                                            <Select
                                                options={mainOptions}
                                                value={selectedDueClearance}
                                                onChange={(option) => {
                                                    setSelectedDueClearance(option);
                                                    if (!option) {
                                                        setSelectedStatus(null);
                                                        setFilterQueryString(prev => {
                                                            const updated = { ...prev };
                                                            delete updated.sort_type;
                                                            delete updated.sort_by;
                                                            return updated;
                                                        });
                                                        const updatedParams = { ...filterQueryString };
                                                        delete updatedParams.sort_type;
                                                        delete updatedParams.sort_by;
                                                        getActivityDatas(0, sortFieldRef.current, "", new URLSearchParams(updatedParams).toString(), true);
                                                    }
                                                }}
                                                isClearable
                                                placeholder="Pre-checks"
                                                styles={reactSelectStyles}
                                            />
                                        </div>
                                        <div style={{ width: "200px" }}>
                                            <Select
                                                options={statusOptions}
                                                value={selectedStatus}
                                                isDisabled={!selectedDueClearance}
                                                onChange={(option) => {
                                                    setSelectedStatus(option);
                                                    setFilterLoading(true);
                                                    setFilterQueryString(prev => {
                                                        let updated = { ...prev };
                                                        if (option) {
                                                            updated.sort_by = option.value;
                                                            updated.sort_type = selectedDueClearance?.value || "";
                                                        } else {
                                                            delete updated.sort_by;
                                                            delete updated.sort_type;
                                                        }
                                                        return updated;
                                                    });
                                                    const newParams = { ...filterQueryString, sort_by: option?.value, sort_type: selectedDueClearance?.value || "" };
                                                    getActivityDatas(0, sortFieldRef.current, option?.value || "", new URLSearchParams(newParams).toString(), true);
                                                }}
                                                isClearable
                                                placeholder="Status"
                                                styles={reactSelectStyles}
                                            />
                                        </div>
                                        <div style={{ width: "230px" }}>
                                            <Select
                                                options={[
                                                    { label: "Pending", value: "pending" },
                                                    { label: "Completed", value: "completed" },
                                                ]}
                                                value={selectedAdmitCardStatus}
                                                onChange={(option) => {
                                                    setSelectedAdmitCardStatus(option);
                                                    setFilterLoading(true);
                                                    const updatedQuery = { ...(filterQueryString || {}) };
                                                    if (option) { updatedQuery.admit_card_status = option.value; }
                                                    else { delete updatedQuery.admit_card_status; }
                                                    setFilterQueryString(updatedQuery);
                                                    getActivityDatas(0, sortFieldRef.current, sortOrderRef.current, updatedQuery, true);
                                                }}
                                                isClearable
                                                placeholder="Issue Status"
                                                styles={reactSelectStyles}
                                            />
                                        </div>
                                        {activity?.activity_event_type?.name?.includes("Admit Card") && (
                                            <div style={{ width: "230px" }}>
                                                <Select
                                                    options={[
                                                        { label: "Yes", value: true },
                                                        { label: "No", value: false },
                                                    ]}
                                                    value={admitCardAvailablity}
                                                    onChange={(option) => {
                                                        setAdmitCardAvailability(option);
                                                        setFilterLoading(true);
                                                        const updatedQuery = { ...(filterQueryString || {}) };
                                                        if (option) { updatedQuery.admit_card_available = option.value; }
                                                        else { delete updatedQuery.admit_card_available; }
                                                        setFilterQueryString(updatedQuery);
                                                        getActivityDatas(0, sortFieldRef.current, sortOrderRef.current, updatedQuery, true);
                                                    }}
                                                    isClearable
                                                    placeholder="Admit Card Available"
                                                    styles={reactSelectStyles}
                                                />
                                            </div>
                                        )}
                                        {activity?.activity_event_type?.name?.includes("Admit Card") && canSendAdmitCardLink && (
                                            <button
                                                onClick={() => setBulkConfirmOpen(true)}
                                                disabled={bulkSending}
                                                title="Bulk Send Admit Card Links"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "transparent",
                                                    border: "1.5px solid #7F56DA",
                                                    borderRadius: "8px",
                                                    padding: "6px 8px",
                                                    cursor: bulkSending ? "not-allowed" : "pointer",
                                                    opacity: bulkSending ? 0.5 : 1,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                {bulkSending ? (
                                                    <span className="spinner-border spinner-border-sm" style={{ color: "#7F56DA" }} role="status" aria-hidden="true" />
                                                ) : (
                                                    <svg fill="#7F56DA" viewBox="0 0 32 32" height="22" width="22" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 25.472q0 2.368 1.664 4.032t4.032 1.664h18.944q2.336 0 4-1.664t1.664-4.032v-8.192l-3.776 3.168v5.024q0 0.8-0.544 1.344t-1.344 0.576h-18.944q-0.8 0-1.344-0.576t-0.544-1.344v-18.944q0-0.768 0.544-1.344t1.344-0.544h9.472v-3.776h-9.472q-2.368 0-4.032 1.664t-1.664 4v18.944zM5.696 19.808q0 2.752 1.088 5.28 0.512-2.944 2.24-5.344t4.288-3.872 5.632-1.664v5.6l11.36-9.472-11.36-9.472v5.664q-2.688 0-5.152 1.056t-4.224 2.848-2.848 4.224-1.024 5.152z"/>
                                                    </svg>
                                                )}
                                            </button>
                                        )}
                                        {activity?.activity_event_type?.name?.includes("Practical") && (
                                            <div style={{ width: "200px" }}>
                                                <Select
                                                    options={invagilationsOptions}
                                                    value={selectedInvigilationsMode}
                                                    onChange={(option) => {
                                                        setSelectedInvigilationsMode(option);
                                                            setFilterLoading(true);
                                                        const updatedQuery = { ...(filterQueryString || {}) };
                                                        if (option) { updatedQuery.is_scanned = option.value === "complete" ? "1" : "0"; }
                                                        else { delete updatedQuery.is_scanned; }
                                                        setFilterQueryString(updatedQuery);
                                                        getActivityDatas(0, sortFieldRef.current, sortOrderRef.current, updatedQuery, true);
                                                    }}
                                                    isClearable
                                                    placeholder="Invigilation"
                                                    styles={{
                                                        ...reactSelectStyles,
                                                        control: (base, state) => ({
                                                            ...reactSelectStyles.control(base, state),
                                                            height: "45px",
                                                            minHeight: "45px",
                                                        }),
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* ── SCROLLABLE: Table area ── */}
                            <div style={{
                                flex: 1,
                                minHeight: 0,           // ← critical
                                display: "flex",        // ← add
                                flexDirection: "column" // ← add
                            }}>
                                {filterLoading && !skipNextLoaderRef.current && (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                        <SpinnerLoader />
                                    </div>
                                )}
                                {!filterLoading && formattedData?.length > 0 && (
                                    <AdvanceTable
                                        columns={columns}
                                        pageCounts={pageCounts}
                                        handlePageChange={handlePageChange}
                                        selectedData={selectedStudent}
                                        data={formattedData}
                                        handleRowClick={handleRowClick}
                                        currentPage={currentPage}
                                        checkbox={false}
                                        handleSort={handleSort}
                                        sortField={sortField}
                                        sortOrder={sortOrder}
                                    />
                                )}
                                {!filterLoading && formattedData?.length === 0 && (
                                    <div style={{
                                        display: "flex", flexDirection: "column", alignItems: "center",
                                        justifyContent: "center", height: "60%", color: "#888",
                                        borderRadius: "8px", textAlign: "center",
                                    }}>
                                        {searchValueRef.current?.trim() ? (
                                            "No Search Results Found."
                                        ) : Object.keys(filterQueryString || {}).length > 0 ? (
                                            filteredAdmitCardCount === 0 ? "No Admit Cards Available." : "No Filtered Results Found."
                                        ) : (
                                            "No Activities Found."
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* RIGHT: SingleActivityDetails (independently scrollable) */}
                        <div className="shortdetails" style={{
                            flex: "0 0 33.33%",
                            maxWidth: "33.33%",
                            display: "flex",        // ← add
                            flexDirection: "column", // ← add
                            overflow: "hidden"       // ← change from overflowY auto
                        }}>
                            <SingleActivityDetails
                                selectedDetails={selectedStudent}
                                setselectedStudent={setselectedStudent}
                                activityId={activityId}
                                getActivityDatas={getActivityDatas}
                                currentPage={currentPage}
                                activity={activity}
                                handleNoDuesClick={handleNoDuesClick}
                                studentInfo={studentInfo}
                                isSearchMode={isSearchMode}
                                filterQueryString={filterQueryString}
                                searchValue={searchValue}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                modalOpenQueryRef={modalOpenQueryRef}
                                getActivityStatsCount={getActivityStatsCount}
                                bumpReconciliationRefreshKey={() => setReconciliationRefreshKey((k) => k + 1)}
                                patchStudentRow={(studentId, patch) => {
                                    const applyPatch = (prev) => {
                                        const results = prev?.students?.results;
                                        if (!Array.isArray(results)) return prev;
                                        return {
                                            ...prev,
                                            students: {
                                                ...prev.students,
                                                results: results.map((s) =>
                                                    s.student_id === studentId ? { ...s, ...patch } : s
                                                ),
                                            },
                                        };
                                    };
                                    setActivity(applyPatch);
                                    setfilterStudent(applyPatch);
                                    // Also patch selectedStudent so the right panel stays in sync
                                    setselectedStudent((prev) =>
                                        prev?.student_id === studentId ? { ...prev, ...patch } : prev
                                    );
                                }}
                                admitCardSocketInfo={admitCardSocketInfo}
                            />
                        </div>
                    </div>

                    <TableLoaderOverlay isLoading={tableLoading} />
                </div>
            )}

            <StudentLedgerDetails
                isOpen={openStudentLedgerReportModal}
                onClose={handleCloseModal}
                selectedFeeDetails={selectedFeeDetails}
            />
            <ConfirmationModal
                isOpen={bulkConfirmOpen}
                title="Bulk Send Admit Card Links"
                message="This will send the admit card download link via WhatsApp to all eligible students in this activity. Do you want to continue?"
                onConfirm={() => { setBulkConfirmOpen(false); handleBulkSendAdmitCardLink(); }}
                onCancel={() => setBulkConfirmOpen(false)}
                isSubmitting={bulkSending}
            />
            <BulkApprovalModal
                isOpen={bulkFinanceConfirmOpen}
                onClose={() => setBulkFinanceConfirmOpen(false)}
                reportType="accounts"
                activityId={activityId}
                onSuccess={() => setReconciliationRefreshKey((k) => k + 1)}
                onRefreshList={() => getActivityDatas(
                    currentPageRef.current,
                    sortFieldRef.current,
                    sortOrderRef.current,
                    buildQueryFromCurrentFilters(),
                    true,
                    true
                )}
            />
            <BulkLibraryApprovalModal
                isOpen={bulkLibraryConfirmOpen}
                onClose={() => setBulkLibraryConfirmOpen(false)}
                activityId={activityId}
                onSuccess={() => setReconciliationRefreshKey((k) => k + 1)}
                onRefreshList={() => getActivityDatas(
                    currentPageRef.current,
                    sortFieldRef.current,
                    sortOrderRef.current,
                    buildQueryFromCurrentFilters(),
                    true,
                    true
                )}
            />
        </>
    );
}